import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { useOwnPastAppointmentsQuery } from '@/hooks/useOwnUpcomingAppointmentsQuery';
import { VisitSummaryRow } from './VisitSummaryRow';

export function PastVisitsList() {
  const { t } = useTranslation('clients');
  const [isOpen, setIsOpen] = useState(false);
  const pastQuery = useOwnPastAppointmentsQuery(isOpen);
  const pastVisits = pastQuery.data === undefined ? [] : pastQuery.data;

  return (
    <details
      className="mt-3"
      onToggle={function trackOpen(toggleEvent) {
        setIsOpen(toggleEvent.currentTarget.open);
      }}
    >
      <summary className="text-xs font-semibold text-zooprimary cursor-pointer">
        {t('visits.pastTitle')}
      </summary>
      <div className="mt-2 space-y-2">
        {pastQuery.isLoading === true ? (
          <div className="py-3 flex justify-center">
            <LoadingSpinner className="w-5 h-5" />
          </div>
        ) : pastVisits.length === 0 ? (
          <p className="text-[12px] text-zoomuted">{t('visits.pastEmpty')}</p>
        ) : (
          pastVisits.map(function renderVisit(visit) {
            return <VisitSummaryRow key={visit.id} visit={visit} />;
          })
        )}
      </div>
    </details>
  );
}
